import { useNavigate, useLocation } from 'react-router-dom';
import { SITE_CONFIG } from '../../config/site';

// Pages where the bar is hidden (booking form is right there)
const HIDDEN_PATHS = ['/contact'];

export default function MobileBottomBar() {
  const navigate = useNavigate();
  const location = useLocation();

  if (HIDDEN_PATHS.includes(location.pathname)) return null;

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-[90] flex" style={{ boxShadow: '0 -1px 0 rgba(201,169,110,0.2)' }}>
      {/* Book Online */}
      <button
        onClick={() => navigate('/contact')}
        className="flex-1 flex items-center justify-center gap-2 py-4 bg-[#C9A96E] text-[#1a1a18] text-xs tracking-[0.15em] uppercase font-medium cursor-pointer border-0"
      >
        <i className="ri-calendar-check-line text-base" />
        Book Online
      </button>

      {/* Divider */}
      <div className="w-px bg-[#1a1a18]/30" />

      {/* Call Now */}
      <a
        href={SITE_CONFIG.phone.href}
        className="flex-1 flex items-center justify-center gap-2 py-4 bg-[#1C1C1A] text-[#C9A96E] text-xs tracking-[0.15em] uppercase"
      >
        <i className="ri-phone-line text-base" />
        Call Now
      </a>
    </div>
  );
}
